<template>
  <div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div class="box">
      <admin-box-item title="파트너 메뉴 관리" subtitle="관리자가 파트너의 메뉴를 설정할 수 있습니다.
      파트너 백오피스 메 전체를 보여줍니다.
      활성화 여부를 선택해서 사용하고 싶은 메뉴를 설정하세요.">
        <!-- 1차 -->
        <div v-for="(menu,idx) in menus" :key="'menu-'+idx">
          <div class="flex space-between lp-table-row">
            <div>{{ menu.name }}</div>
            <toggle-button @change="e => menu.enable = e.value"
                           :value="menu.enable"
                           :sync="true"
                           class="changed-font"
                           :width="70"
                           :height="24"
                           :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
          </div>
          <!-- 2차 -->
          <div v-for="(child,child_idx) in menu.child" :key="'child-'+child_idx">
            <div class="flex space-between lp-table-row">
              <div>{{ child.name }}</div>
              <toggle-button @change="e => child.enable = e.value"
                             :value="child.enable"
                             :sync="true"
                             class="changed-font"
                             :width="70"
                             :height="24"
                             :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
            </div>
            <!-- 3차 -->
            <div v-for="(gchild, gchild_idx) in child.child" :key="'gchild-'+gchild_idx">
              <div class="flex space-between lp-table-row">
                <div>{{ gchild.name }}</div>
                <toggle-button @change="e => gchild.enable = e.value"
                               :value="gchild.enable"
                               :sync="true"
                               class="changed-font"
                               :width="70"
                               :height="24"
                               :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
              </div>
            </div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

  </div>
</template>
<script>
  import ToggleButton from "vue-js-toggle-button/src/Button";

  export default {
    components: {ToggleButton},
    data() {
      return {
        menus: []
      }
    },
    created() {
      this.getPartnerMenuSetting();
    },
    methods: {
      getPartnerMenuSetting() {
        this.$axios.get('admin/menu/setting').then(res=>{
          let menus = res.data;
          this.setMenus(menus);
          this.menus = this.cloneItem(menus);
        })
      },
      save() {
        this.$store.commit('setLoading', true);
        this.$axios.patch('admin/menu/setting', {
          menus: this.menus
        }).then(res=>{
          if(res.status===200) {
            this.$store.commit('setLoading', false);
            this.toast('변경사항이 저장되었습니다.');
          }
        }).catch(err => {
          this.$store.commit('setLoading', false);
          this.toast('서버에 오류가 있습니다.');
        });
      },
      setMenus (menus) {
        menus.forEach(menu=> {
          if(!menu.child) {
            menu['child'] = [];
          }
        });
        for(let i=0; i<menus.length; i++) {
          // enable 없다면 추가
          if(Object.keys(menus[i]).indexOf('enable')===-1) {
            menus[i].enable = true;
          }
          let child = menus[i].child;
          if(Object.keys(menus[i]).indexOf('child')===-1) continue;
          else if(child.length>0) this.setMenus(child);
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-table-row
    padding 6px 0
    border-bottom 1px solid rgb(152, 152, 152)

</style>
